import React, { useEffect, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";
import ReactDatatable from "@ashvin27/react-datatable";
import EditProduct from "./EditProduct";
import { useDispatch, useSelector } from "react-redux";
import DeletePop from "../../../Components/DeletePop";
import FileViewer from "../../../Components/FileViewer";
export default function ViewProduct(props) {
  const productList = useSelector((state) => state.Inventory.Products);
  const CategoryList = useSelector((state) => state.Inventory.Category);
  const GodownList = useSelector((state) => state.Inventory.Godown);
  const BrandList = useSelector((state) => state.Inventory.Brands);
  const { url } = useRouteMatch();
  const [selectedId, SetselectedId] = useState(false);
  const [showModal, Setmodal] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [selectedBrand, setSelectBrand] = useState("");
  const [selectedGodown, setSelectGodown] = useState("");
  const [selectedCategory, setSelectCategory] = useState("");
  const dispatch = useDispatch();
  const columns = [
    {
      key: "name",
      text: "Product Name",
      width: 450,
      sortable: true,
      cell: (record) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={record.image[0]}
              alt={record.name}
              onClick={() => {
                SetselectedFile(record.image[0]);
                Setmodal(true);
              }}
            />
            <div className="media-body">
              <p className="lh-1">{record.name}</p>
              <small>{record.id}</small>
            </div>
          </div>
        );
      },
    },
    {
      key: "category",
      text: "Category",
      sortable: true,
    },
    {
      key: "store",
      text: "Godown",
      sortable: true,
    },
    {
      key: "brand",
      text: "Brand",
      sortable: true,
      cell: (record) => {
        return <>{record.brand ? record.brand.name : ""}</>;
      },
    },
    {
      key: "stock",
      text: "Stock",
      sortable: true,
      cell: (record) => {
        return (
          <p className="d-flex">
            {record.stock}
            {record.stock <= record.minqty ? (
              record.stock < 0 ? (
                <span className="material-icons text-warning">warning</span>
              ) : (
                <span className="material-icons text-danger">
                  priority_high
                </span>
              )
            ) : (
              ""
            )}
          </p>
        );
      },
    },
    {
      key: "unit",
      text: "U.Stock",
      sortable: true,
      cell: (record) => {
        return (
          <React.Fragment>
            {record.stock * record.size}
            {record.unit}
          </React.Fragment>
        );
      },
    },
    {
      key: "price",
      text: "S.Price",
      sortable: true,
    },
    {
      key: "cprice",
      text: "LP.Rate",
      sortable: true,
    },
    {
      key: "margin",
      text: "Margin",
      sortable: true,
      cell: (record) => {
        return (
          <React.Fragment>
            {(((record.price - record.cprice) * 100) / record.cprice).toFixed(
              2
            )}
            %
          </React.Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "table-actions",
      width: 150,
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <React.Fragment>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/View/${record.id}`}
            >
              <span className="material-icons-outlined">visibility</span>
            </Link>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${record.id}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              disabled={false}
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(record.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      excel: true,
      print: true,
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };

  useEffect(() => {
    if (props.location.state !== null) {
      fetchProducts();
    }
    fetchInventory();
  }, []);

  const fetchProducts = () => {
    ApiConnect.get(
      `/Module/Inventory/Product/Details?category=${selectedCategory}&godown=${selectedGodown}&brand=${selectedBrand}`
    )
      .then((response) => {
        let Products = response.data;
        dispatch({ type: "SET_INVENTORY_PRODUCTS", payload: { Products } });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchInventory = () => {
    ApiConnect.get("/Module/Inventory/Product/Components")
      .then((response) => {
        let Godown = response.data.godown;
        let Brand = response.data.brand;
        let Category = response.data.category;
        dispatch({ type: "SET_INVENTORY_GODOWN", payload: { Godown } });
        dispatch({
          type: "SET_INVENTORY_BRANDS",
          payload: { Brand },
        });
        dispatch({
          type: "SET_INVENTORY_CATEGORY",
          payload: { Category },
        });
      })
      .catch((error) => console.log(error));
  };
  const SetviewerTrigger = () => {
    Setmodal(false);
  };
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <div className="card-body">
          <div className="row justify-content-center">
            <div className="form-group col-md-3">
              <label>Category</label>
              <select
                value={selectedCategory}
                className="form-control"
                onChange={(e) => setSelectCategory(e.target.value)}
              >
                <option value="">Select Category</option>
                {CategoryList.map((cat, catind) => (
                  <option value={cat.catid} key={catind}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Brand</label>
              <select
                className="form-control"
                value={selectedBrand}
                onChange={(e) => setSelectBrand(e.target.value)}
              >
                <option value="">Select Brand</option>
                {BrandList.map((brd, brdind) => (
                  <option value={brd.id} key={brdind}>
                    {brd.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Godown</label>
              <select
                className="form-control"
                value={selectedGodown}
                onChange={(e) => setSelectGodown(e.target.value)}
              >
                <option value="">Select Godown</option>
                {GodownList.map((gdm, gdmind) => (
                  <option value={gdm.godownid} key={gdmind}>
                    {gdm.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <br />
              <button className="btn btn-secondary col">Reset</button>
              <button
                className="btn btn-primary col"
                onClick={() => fetchProducts()}
              >
                Fetch
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="dataTables_wrapper">
            <ReactDatatable
              className="table table-separated table-responsive"
              config={config}
              records={productList || []}
              columns={columns}
            />
          </div>
          <DeletePop
            trigger={triggerModal}
            delUrl={`/Module/Inventory/Product/DeleteProduct?id=${selectedId}`}
            hideTrigger={SettriggerModal}
            fallAction={fetchProducts}
          />
          <FileViewer
            trigger={showModal}
            doc={selectedFile}
            hideTrigger={SetviewerTrigger}
          />
        </div>
      </div>
    </div>
  );
}
